import { authStorage } from '~/lib/authStorage';
import { isBefore } from 'date-fns';

export const useParkerStore = defineStore('parkerStore', {
  state: () => ({
    parker: null,
  }),
  actions: {
    setParker (parker) {
      this.parker = parker;
    },
    setParkerReservations (reservations) {
      this.parker.reservations = reservations;
    },
    reset () {
      this.parker = null;
    }
  },
  getters: {
    getParker: (state) => state.parker,
    getParkerParkingPacks: (state) => {
      const hasParkingAvailable = (pack) => pack.parkingsUsed < pack.parkingPack.allowedParkings;
      const purchasedPacks = state.parker?.parkerParkingPacks.filter((pack) => pack.order.status === 'PAYMENT_COMPLETE');
      return purchasedPacks?.filter((pack) => hasParkingAvailable(pack));
    },
    getParkerReservations: (state) =>
      state.parker?.reservations?.filter((reservation) => reservation.status === 'CONFIRMED'),
    getParkerSortedReservations: (state) => {
      const reservations =
        state.parker?.reservations?.filter((reservation) => reservation.status === 'CONFIRMED');
      return reservations?.filter((reservation) => isBefore(reservation.checkoutDatetime, new Date()))
        .sort((a, b) => new Date(b.checkoutDatetime) - new Date(a.checkoutDatetime));
    },
    getParkerCancelledReservations: (state) =>
      state.parker?.reservations.filter((reservation) => reservation.status === 'CANCELLED'),
    getParkerVehicles: (state) => state.parker?.vehicles.filter((vehicle) => vehicle.status === 'ACTIVE'),
    getParkerDeletedVehicles: (state) => state.parker?.vehicles.filter((vehicle) => vehicle.status === 'DELETED'),
    getUpcomingReservations: (state) => {
      const reservations =
        state.parker?.reservations?.filter((reservation) => reservation.status === 'CONFIRMED');
      return reservations?.filter((reservation) => !isBefore(reservation.checkoutDatetime, new Date()));
    }
  },
  persist: {
    storage: authStorage
  },
});
